const dateLocale = require('date-fns/locale/en');

export default {
  dateLocale,
  dateFormat: 'MM-DD-YYYY',
  dateFormatReadable: 'dddd MM/DD',
};
